// extracted by mini-css-extract-plugin
export default {"slideshow":"Notes__slideshow___SqNqi"};